import type { JobDetailData } from "@apis/videoCreatingService";
import type { UserAssetV2Record } from "@apis/http/api";

export const ASPECT_RATIO_MAP: Record<string, string> = {
  RATIO_9_16: "9:16",
  RATIO_16_9: "16:9",
};

export const formatDate = (date?: number | string) => {
  if (!date) return "-";
  const d = new Date(typeof date === "number" ? date : date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year} / ${month} / ${day}`;
};

export const getRecordVideoUrl = (record?: UserAssetV2Record | null) => {
  const context = record?.jobItem?.context as Record<string, unknown> | undefined;
  return (typeof context?.videoUrl === "string" ? context.videoUrl : undefined) || record?.url || undefined;
};

export const getVideoUrl = (jobDetail: JobDetailData | null, record?: UserAssetV2Record | null) => {
  return jobDetail?.output?.videoUrl || getRecordVideoUrl(record);
};

export const getAspectRatio = (jobDetail: JobDetailData | null, record?: UserAssetV2Record | null) => {
  const context = record?.jobItem?.context as Record<string, unknown> | undefined;
  return jobDetail?.input?.aspectRatio || (typeof context?.aspectRatio === "string" ? context.aspectRatio : undefined);
};

/** 视频复刻类型判断：优先取任务详情 jobType，回退到列表项 jobItem.jobType */
export const isVideoRemake = (jobDetail: JobDetailData | null, record?: UserAssetV2Record | null) => {
  return jobDetail?.jobType === "VIDEO_REMAKE" || record?.jobItem?.jobType === "VIDEO_REMAKE";
};

/**
 * 复刻任务的源（参考）视频信息。
 * `videoUrl` / `videoCoverImageUrl` 运行时由 input 携带，但 `JobDetailInput` TS 类型未声明，故松散读取。
 */
export const getSourceVideo = (jobDetail: JobDetailData | null) => {
  const input = jobDetail?.input as Record<string, unknown> | undefined;
  const url = typeof input?.videoUrl === "string" ? input.videoUrl : undefined;
  const cover = typeof input?.videoCoverImageUrl === "string" ? input.videoCoverImageUrl : undefined;
  return { url, cover };
};
